var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelefone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 25.8333C31.25 25.8333 29.25 25.5 27.3833 24.8833C27.0903 24.79 26.7774 24.7779 26.478 24.8483C26.1787 24.9188 25.904 25.0691 25.6833 25.2833L22.0167 28.95C17.2898 26.5453 13.4452 22.7065 11.0333 17.9833L14.7 14.3C15.1667 13.85 15.3 13.2 15.1167 12.6167C14.4844 10.6968 14.1637 8.688 14.1667 6.66667C14.1667 5.75 13.4167 5 12.5 5H6.66667C5.75 5 5 5.75 5 6.66667C5 22.3167 17.6833 35 33.3333 35C34.25 35 35 34.25 35 33.3333V27.5C35 26.5833 34.25 25.8333 33.3333 25.8333ZM20 5V21.6667L25 16.6667H35V5H20Z",
    fill: "#FD9E02"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/telefone.08b7a0382d73b35b4ee74311c9a725f3.svg";
export { ForwardRef as ReactComponent };